import { render, staticRenderFns } from "./UsersViewDetails.vue?vue&type=template&id=11191050&"
import script from "./UsersViewDetails.vue?vue&type=script&lang=js&"
export * from "./UsersViewDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports